module.exports = __webpack_public_path__ + "static/media/FASNYLogoProcess8.3919597b.jpg";